// (() => {
//   const root = document.getElementById('EggHunt');
//   if (!root) return;

//   const requiredRaw = Number(root.dataset.required);
//   const required = Number.isFinite(requiredRaw) && requiredRaw > 0 ? requiredRaw : 5;
//   const code = root.dataset.code || 'YU2026';
//   const redirect = root.dataset.redirect || '/collections/all';

//   const STORAGE_KEY = `egg_hunt_found_${code}`;

//   const $badge = root.querySelector('.egg-hunt__badge');
//   const $panel = root.querySelector('#egg-hunt-panel');
//   const $close = root.querySelector('.egg-hunt__close');

//   const $count = root.querySelector('.egg-hunt__count');
//   const $required = root.querySelector('.egg-hunt__required');
//   const $count2 = root.querySelector('.egg-hunt__count2');
//   const $required2 = root.querySelector('.egg-hunt__required2');

//   const $modal = root.querySelector('.egg-hunt__modal');
//   const $copy = root.querySelector('.egg-hunt__copy');
//   const $code = root.querySelector('.egg-hunt__code');
//   const $apply = root.querySelector('.egg-hunt__apply');
//   const $modalClose = root.querySelector('.egg-hunt__modal-close');

//   $required.textContent = String(required);
//   $required2.textContent = String(required);
//   $code.textContent = code;
//   $apply.setAttribute('href', `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`);

//     const must = [$badge, $panel, $close, $modal, $copy, $apply, $modalClose, $count, $required, $count2, $required2, $code];
//     if (must.some(el => !el)) return;

//   const readFound = () => {
//     try {
//       return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
//     } catch {
//       return [];
//     }
//   };

//   const writeFound = (arr) => {
//     localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
//   };

//   const updateUI = () => {
//     const found = readFound();
//     const n = found.length;

//     $count.textContent = String(n);
//     $count2.textContent = String(n);

//     // 已找到的蛋：隱藏
//     document.querySelectorAll('.egg[data-egg-id]').forEach((el) => {
//       const id = el.getAttribute('data-egg-id');
//       if (found.includes(id)) el.classList.add('is-found');
//     });

//   };
//   // 點背景關閉（點到遮罩本身才關，不會誤關卡片）
//         $modal.addEventListener('click', (e) => {
//         if (e.target === $modal) closeModal();
//     });

//     // ESC 關閉
//     document.addEventListener('keydown', (e) => {
//         if (e.key === 'Escape' && !$modal.hidden) closeModal();
//     });

//   const openPanel = () => {
//     $panel.hidden = false;
//     $badge.setAttribute('aria-expanded', 'true');
//   };

//   const closePanel = () => {
//     $panel.hidden = true;
//     $badge.setAttribute('aria-expanded', 'false');
//   };

//     const openModal = () => {
//         const found = readFound();
//         if (found.length < required) return;
//         $modal.classList.remove('is-hidden');
//         closePanel();
//     };

//     const closeModal = () => {
//         $modal.classList.add('is-hidden');
//     };

//   // Badge toggle
//   $badge.addEventListener('click', () => {
//     if ($panel.hidden) openPanel();
//     else closePanel();
//   });

//   $close.addEventListener('click', closePanel);

//   // Copy code
//   $copy.addEventListener('click', async () => {
//     try {
//       await navigator.clipboard.writeText(code);
//       $copy.textContent = 'Copied';
//       setTimeout(() => ($copy.textContent = 'Copy'), 1200);
//     } catch {
//       // fallback
//       const tmp = document.createElement('textarea');
//       tmp.value = code;
//       document.body.appendChild(tmp);
//       tmp.select();
//       document.execCommand('copy');
//       tmp.remove();
//     }
//   });

//   $modalClose.addEventListener('click', closeModal);


//     // 點蛋（用事件委派：就算蛋在不同頁面/不同區塊動態出現也OK）
//     document.addEventListener('click', (e) => {
//         const egg = e.target.closest('.egg[data-egg-id]');
//         if (!egg) return;

//         const id = egg.getAttribute('data-egg-id');
//         const found = readFound();

//         if (!found.includes(id)) {
//             found.push(id);
//             writeFound(found);
//             egg.classList.add('is-found');
//             updateUI();

//             if (found.length >= required) openModal();
//         }
//     });



//   updateUI();
// })();


(() => {
  const TOTAL_EGGS = 5;
  const CAMPAIGN_ID = 'egg_hunt_2026-1';
  const DISCOUNT_CODE = 'MANTELPIECE';

  const STORAGE_WINNER = `${CAMPAIGN_ID}_winner_index`;
  const STORAGE_WON = `${CAMPAIGN_ID}_won`;
  const STORAGE_CODE = `${CAMPAIGN_ID}_code`; // 讓 code 可被 drawer 再顯示
  const EGG_MESSAGES = {
    0: 'Empty. Keep exploring.',
    1: 'A little further... keep exploring other pages.',
    2: 'So close... keep exploring this page.',
    3: 'Close... .seek the next fragrance.',
    4:'Nice try... find the scent shown below.'
  };
  // ===== Modal helpers =====
  function openEggModal(message) {
    const modal = document.getElementById('egg-modal');
    const text = document.getElementById('egg-modal-text');
    if (!modal || !text) return;

    text.textContent = message;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }
  function closeEggModal() {
    const modal = document.getElementById('egg-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  // ===== Drawer helpers =====
  function showBadge() {
    const badge = document.getElementById('egg-badge');
    if (badge) badge.hidden = false;
  }
  function setDrawerCode(code) {
    const codeEl = document.getElementById('egg-drawer-code');
    if (codeEl) codeEl.textContent = code;
  }
  function openDrawer() {
    const drawer = document.getElementById('egg-drawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    const drawer = document.getElementById('egg-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }
  function hideAllEggs() {
    document.querySelectorAll('[data-egg-index]').forEach(egg => {
      egg.style.display = 'none';
    });
  }

  async function copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      // fallback
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    }
  }

  // ===== Winner index (per user) =====
  let winnerIndex = Number(localStorage.getItem(STORAGE_WINNER));
  if (!Number.isInteger(winnerIndex) || winnerIndex < 0 || winnerIndex >= TOTAL_EGGS) {
    winnerIndex = Math.floor(Math.random() * TOTAL_EGGS);
    localStorage.setItem(STORAGE_WINNER, String(winnerIndex));
  }

  // ===== If already won: eggs hidden + badge shown =====
  function initWonState() {
    const won = localStorage.getItem(STORAGE_WON) === 'true';
    if (!won) return;

    hideAllEggs();

    const savedCode = localStorage.getItem(STORAGE_CODE) || DISCOUNT_CODE;
    setDrawerCode(savedCode);

    const badge = document.getElementById('egg-badge');
    if (badge) badge.hidden = false;
  }

  // ✅ DOM ready 後再做一次（避免 badge 還沒渲染就執行）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWonState);
  } else {
    initWonState();
  }


  // ===== Global click handlers (delegate) =====
  document.addEventListener('click', async (e) => {
    // Close modal
    if (e.target.closest('#egg-modal-close')) {
      closeEggModal();
      return;
    }

    // Open drawer via badge
    if (e.target.closest('#egg-badge')) {
      const savedCode = localStorage.getItem(STORAGE_CODE) || DISCOUNT_CODE;
      setDrawerCode(savedCode);
      openDrawer();
      return;
    }

    // Close drawer
    if (e.target.closest('#egg-drawer-close')) {
      closeDrawer();
      return;
    }

    // Copy
    if (e.target.closest('#egg-copy')) {
      const code = (localStorage.getItem(STORAGE_CODE) || DISCOUNT_CODE).trim();
      const hint = document.getElementById('egg-copy-hint');
      const ok = await copyToClipboard(code);
      if (hint) hint.textContent = ok ? 'Copied ✨' : 'Copy failed, please copy manually.';
      return;
    }

    // Egg click
    const egg = e.target.closest('[data-egg-index]');
    if (!egg) return;

    if (localStorage.getItem(STORAGE_WON) === 'true') {
      // 已中：直接打開 drawer（不用再提示）
      const savedCode = localStorage.getItem(STORAGE_CODE) || DISCOUNT_CODE;
      setDrawerCode(savedCode);
      showBadge();
      openDrawer();
      return;
    }

    const idx = Number(egg.dataset.eggIndex);
    if (!Number.isInteger(idx)) return;

    if (idx === winnerIndex) {
      localStorage.setItem(STORAGE_WON, 'true');
      localStorage.setItem(STORAGE_CODE, DISCOUNT_CODE);

      openEggModal(`Success! You cracked the code：${DISCOUNT_CODE}`);

      // ✅ 中獎後：蛋消失 + badge 出現
      hideAllEggs();
      setDrawerCode(DISCOUNT_CODE);
      showBadge();
    } else {
      const message = egg.dataset.eggMessage || 'Empty. Keep exploring.';
      openEggModal(message);
    }
  }, true);

  // ESC 關閉
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeEggModal();
      closeDrawer();
    }
  });
})();
